import { gql } from "@apollo/client";
import { USER_FRAGMENT } from ".";

export const GET_USER = gql`
  query User {
    user {
      ...User
    }
  }
  ${USER_FRAGMENT}
`;
